/** The widths a picture can be given, as shares of the text column. The public page only accepts these. */
export const PICTURE_WIDTHS = ["25%", "50%", "75%", "100%"] as const;
